/* @jsx h */

import { TableStatus } from "@lemmonhq/types";
import { defineComponent, h } from "vue";
import { TableVisualProps } from "./types";
import { CashierCell } from "./CashierCell";
import { BarCell } from "./BarCell";
import { AssignedTableCell } from "./AssignedTableCell";
import { UnassignedTableCell } from "./UnassignedTableCell";

export const FloorPlanCell = defineComponent<TableVisualProps>({
  name: "FloorPlanCell",
  props: [
    "planConfig",
    "tableStatus",
    "onFloorPlanCellChange",
    "tables",
    "onTableOpen",
    "isEditable",
    "dropModeState",
    "reservations",
    "reservationsByTable",
    "isLiveDay",
    "nowMs",
  ],
  setup(props) {
    // Compute table size and seat count

    return () => (
      <div
        class="w-full h-full flex items-center justify-center text-[var(--floor-plan-empty-content)] group p-[8px]"
        style="container-type: size;"
      >
        <div class="relative w-full h-full flex flex-col justify-start items-center group">
          {(() => {
            // Handle different types based on planConfig.type
            if (props.planConfig.type === "cashier") {
              return (
                <CashierCell
                  tables={props.tables}
                  planConfig={props.planConfig}
                  onFloorPlanCellChange={props.onFloorPlanCellChange}
                  onTableOpen={props.onTableOpen}
                />
              );
            } else if (props.planConfig.type === "bar") {
              return (
                <BarCell
                  tables={props.tables}
                  planConfig={props.planConfig}
                  onFloorPlanCellChange={props.onFloorPlanCellChange}
                  onTableOpen={props.onTableOpen}
                />
              );
            } else if (props.planConfig.type === "table" && props.tableStatus) {
              return (
                <AssignedTableCell
                  tables={props.tables}
                  planConfig={props.planConfig}
                  tableStatus={props.tableStatus as TableStatus}
                  onFloorPlanCellChange={props.onFloorPlanCellChange}
                  onTableOpen={props.onTableOpen}
                  dropModeState={props.dropModeState}
                  reservations={props.reservations}
                  reservationsByTable={props.reservationsByTable}
                  isLiveDay={props.isLiveDay}
                  nowMs={props.nowMs ?? Date.now()}
                />
              );
            } else {
              // Default to unassigned table cell for undefined type or table without tableStatus
              return (
                <UnassignedTableCell
                  tables={props.tables}
                  planConfig={props.planConfig}
                  onFloorPlanCellChange={props.onFloorPlanCellChange}
                  onTableOpen={props.onTableOpen}
                />
              );
            }
          })()}
        </div>
      </div>
    );
  },
});
